export const DEFAULT_MODAL_WIDTH = 1000
export const SMALL_MODAL_WIDTH = 700

export const ICURE_CLOUD_URL = 'https://api.icure.cloud'
export const MSG_GW_URL = 'https://msg-gw.icure.cloud'
export const SPEC_ID = process.env.REACT_APP_EXTERNAL_SERVICES_SPEC_ID
export const PROCESS_ID = process.env.REACT_APP_EMAIL_AUTHENTICATION_PROCESS_ID
export const APPLICATION_ID = process.env.REACT_APP_APPLICATION_ID

export const DATE_FORMAT = 'dd.MM.yyyy'
export const DATE_FORMAT_TO_DISPLAY = 'DD.MM.YYYY'

export enum HubEnum {
  RSB = 'rsb',
  RSW = 'rsw',
  COZO = 'cozo',
  VITALINK = 'vitalink',
}

export const hubsTitles: Record<HubEnum, string> = {
  [HubEnum.RSW]: 'Réseau Santé Wallon',
  [HubEnum.RSB]: 'Réseau Santé Bruxellois',
  [HubEnum.COZO]: 'CoZo: Collaboratief Zorgplatform',
  [HubEnum.VITALINK]: 'Vitalink',
}
export const PRACTITIONER_HUB_ID_IDENTIFIER = 'HUB_ID'
export const PRACTITIONER_FHC_URL_IDENTIFIER = 'FHC_URL'
export const PATIENT_ID_CARD_IDENTIFIER = 'id_card_number'
